(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wy-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-accordion')) {
    customElements.define('wy-accordion', class extends HTMLElement {
      connectedCallback() {
        this.items = this.querySelectorAll('[data-accordion-item]');
        this.items.forEach((item) => {
          const header = item.querySelector('.ai-accordion-header');
          header.addEventListener('click', () => this.toggle(item, header));
        });
      }
      toggle(item, header) {
        const active = item.classList.contains('active');
        this.items.forEach((o) => { if (o !== item) { o.classList.remove('active'); o.querySelector('.ai-accordion-header').setAttribute('aria-expanded', 'false'); } });
        item.classList.toggle('active', !active);
        header.setAttribute('aria-expanded', String(!active));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-collection-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-collection-grid')) {
    customElements.define('wy-collection-grid', class extends HTMLElement {
      connectedCallback() {
        const carousel = this.querySelector('[data-carousel]');
        const cards = this.querySelectorAll('[data-card]');
        const dotsBox = this.querySelector('[data-dots]');
        if (!carousel || !dotsBox || window.innerWidth > 768) return;
        dotsBox.innerHTML = '';
        cards.forEach((c, i) => { const d = document.createElement('div'); d.className = 'ai-collection-grid__dot' + (i === 0 ? ' active' : ''); dotsBox.appendChild(d); });
        const dots = dotsBox.children; let cur = 0, t;
        carousel.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => {
          const w = cards[0].offsetWidth; const gap = parseInt(getComputedStyle(carousel).gap) || 0;
          const n = Math.round(carousel.scrollLeft / (w + gap));
          if (n !== cur && dots[n]) { dots[cur].classList.remove('active'); dots[n].classList.add('active'); cur = n; }
        }, 100); }, { passive: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-faq')) {
    customElements.define('wy-faq', class extends HTMLElement {
      connectedCallback() {
        this.items = this.querySelectorAll('[data-faq-item]');
        this.items.forEach((item) => {
          const btn = item.querySelector('.ai-faq-question-button');
          btn.addEventListener('click', () => {
            const active = item.classList.contains('active');
            this.items.forEach((o) => { if (o !== item) this.close(o); });
            active ? this.close(item) : this.open(item);
          });
        });
      }
      open(item) { item.classList.add('active'); item.querySelector('button').setAttribute('aria-expanded', 'true'); const w = item.querySelector('.ai-faq-answer-wrapper'); w.style.maxHeight = w.firstElementChild.scrollHeight + 'px'; }
      close(item) { item.classList.remove('active'); item.querySelector('button').setAttribute('aria-expanded', 'false'); item.querySelector('.ai-faq-answer-wrapper').style.maxHeight = '0'; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-marquee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-marquee')) customElements.define('wy-marquee', class extends HTMLElement {});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-perso"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__wyPersoInit) return; window.__wyPersoInit = true;
    function cartForm() {
      var f = document.querySelector('form[action*="/cart/add"]');
      if (!f) { var b = document.querySelector('[name="add"]'); if (b) f = b.closest('form'); }
      return f;
    }
    function fields() { return Array.prototype.slice.call(document.querySelectorAll('[data-wy-perso]')); }
    function sync(form) {
      fields().forEach(function (input) {
        var name = 'properties[' + input.getAttribute('data-property') + ']';
        var hidden = null;
        Array.prototype.forEach.call(form.querySelectorAll('input[type="hidden"]'), function (h) { if (h.name === name) hidden = h; });
        if (!hidden) { hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = name; form.appendChild(hidden); }
        hidden.value = input.value || '';
      });
    }
    function validate(form) {
      var ok = true;
      sync(form);
      fields().forEach(function (input) {
        if (input.getAttribute('data-required') === 'true' && input.value.trim() === '') {
          ok = false; input.classList.add('custom-perso-error');
          var e = document.getElementById(input.id + '-error'); if (e) e.classList.add('custom-perso-error-visible');
          input.scrollIntoView({ behavior: 'smooth', block: 'center' }); input.focus();
        }
      });
      return ok;
    }
    function init() {
      var form = cartForm(); if (!form) return;
      fields().forEach(function (input) {
        if (input.dataset.bound) return; input.dataset.bound = '1';
        input.addEventListener('input', function () {
          sync(form);
          if (input.value.trim() !== '') { input.classList.remove('custom-perso-error'); var e = document.getElementById(input.id + '-error'); if (e) e.classList.remove('custom-perso-error-visible'); }
        });
      });
      sync(form);
      if (!form.dataset.wyGuard) {
        form.dataset.wyGuard = '1';
        form.addEventListener('submit', function (e) { if (!validate(form)) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } }, true);
      }
      document.querySelectorAll('[name="add"], .sticky-add-to-cart__button').forEach(function (btn) {
        if (btn.dataset.wyGuard) return; btn.dataset.wyGuard = '1';
        btn.addEventListener('click', function (e) { if (!validate(form)) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); } }, true);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    new MutationObserver(function () { init(); }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wy-reviews-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wy-review-carousel')) {
    customElements.define('wy-review-carousel', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        const cards = this.querySelectorAll('[data-card]');
        const dotsBox = this.querySelector('[data-dots]');
        if (!track || !cards.length) return;
        dotsBox.innerHTML = '';
        const dots = [];
        cards.forEach((c, i) => {
          const d = document.createElement('span');
          d.className = 'pdp-review-carousel__dot' + (i === 0 ? ' pdp-review-carousel__dot--active' : '');
          d.addEventListener('click', () => { track.scrollTo({ left: c.offsetLeft, behavior: 'smooth' }); });
          dotsBox.appendChild(d); dots.push(d);
        });
        let idx = 0;
        const setActive = (i) => { dots.forEach((d, k) => d.classList.toggle('pdp-review-carousel__dot--active', k === i)); idx = i; };
        track.addEventListener('scroll', () => { const w = cards[0].offsetWidth || 1; setActive(Math.round(track.scrollLeft / w)); }, { passive: true });
        this._timer = setInterval(() => { if (this.matches(':hover')) return; const next = (idx + 1) % cards.length; track.scrollTo({ left: cards[next].offsetLeft, behavior: 'smooth' }); }, 5000);
      }
      disconnectedCallback() { clearInterval(this._timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
